import axios from 'axios'

export default {
  initNewDevice: () => axios.post(`/api/v2/cms/init`),
  addNewUndefinedDevice: (placeId, sixDigitsKey) => axios.put(`/api/v2/cms/init/${placeId}?sixDigitsKey=${sixDigitsKey}`),
  testDeviceIdentity: mac => axios.get(`/api/v2/cms/init/identity/{mac}`)
}
